export { default as UploadSolidIcon } from './UploadSolidIcon';
